"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMatchesSearchInputValue = void 0;
var getMatchesSearchInputValue = exports.getMatchesSearchInputValue = function getMatchesSearchInputValue(instrument, instrumentSearchInputString, showFullNameInstrument) {
  return showFullNameInstrument ? "".concat(instrument.Product1FullName).concat(instrument.Product2FullName).toLowerCase().includes(instrumentSearchInputString.toLowerCase()) : "".concat(instrument.Product1Symbol).concat(instrument.Product2Symbol).toLowerCase().includes(instrumentSearchInputString.toLowerCase());
};